import {useGetAndSet} from "./useGetAndSet";
import {createSetDepartmentsDataAction} from "../actions/dataActions";


export const useDepartmentsData = (params, dataFresh, nofetch) => {
    return useGetAndSet("departments", params, createSetDepartmentsDataAction, dataFresh, nofetch);
};